import { clearReportAccessCache } from './reportCache';

const removeTokens = () => {
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('googleIdToken');
  localStorage.removeItem('persist:pms');
  // Cached Power BI embed tokens (sessionStorage) must not outlive the login.
  clearReportAccessCache();
};

export default removeTokens;
